type TableProps = {
  rows: {
    column: {
      cell: string;
    }[];
  }[];
};

export const Table: React.FC<TableProps> = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return null;
  }

  return (
    <div className="overflow-x-scroll py-5 md:overflow-auto">
      <table className="min-w-full">
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.column.map((col, colIndex) => (
                <td key={colIndex} className="pr-2" dangerouslySetInnerHTML={{ __html: col.cell }} />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
